


const GoogleMap = () => {
    return (
        <div className="map-area">
            <div className="maps">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1949.0678297174122!2d76.5824981!3d12.30664985!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3baf7b3c6a374923%3A0x1ebe0d2283e2fec2!2sPreethi%20layout%2C%20Deepanagar%2C%20Mysuru%2C%20Karnataka%20570026!5e0!3m2!1sen!2sin!4v1726661218975!5m2!1sen!2sin" ></iframe>
            </div>
        </div>
    );
}
 
export default GoogleMap;